import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../shared/services/auth.service';
import { CapacitorHttp, HttpOptions } from '@capacitor/core';
import { jwtDecode } from "jwt-decode";
import { StorageService } from '../shared/services/storage.service';
import { Subscription } from 'rxjs';
import { AppConfig } from '../app.config';

export interface StateData {
  id: string;
  platform: 'web' | 'native';
  [code_challange: string]: any;
  access_denied: boolean;
}

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
})

export class AuthComponent {
  public pageMessage: string = "Redirecting...";
  private readonly networkSubscription!: Subscription;
  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly authService: AuthService,
    private readonly storageService: StorageService,
  ) {

    this.networkSubscription = this.authService.isOnline$.subscribe((status) => {
      const state: string = this.route.snapshot.queryParamMap.get('state') ?? '';
      if (state) {
        const state_data = jwtDecode<StateData>(state);
        const platform = state_data.platform;
        const code: string = this.route.snapshot.queryParamMap.get('code') ?? '';
        const logout: string = this.route.snapshot.queryParamMap.get('logout') ?? '';
        const error: string = this.route.snapshot.queryParamMap.get('error') ?? '';

        if (code || logout || error) {
          // this.authService.isLoginInProgress = true;
          this.authMiddlewareHandler(state, code, state_data)
        } else {
          this.networkSubscription?.unsubscribe();
        }
      }
    });
  }

  authMiddlewareHandler(state: string, code: string, state_data: StateData, retry: number = 0) {
    console.log('AuthComponent authMiddlewareHandler invoked');
    const platform = state_data.platform;
    if (code) {
      this.pageMessage = "Authorizing...";
      if (platform === 'native') {
        const options: HttpOptions = {
          url: `${AppConfig.settings?.SIGNALR_WRAPPER_API_BASE_URL}/broadcast`,
          headers: {
            'Content-Type': 'application/json',
          },
          data: { state: state, code, userId: state_data.id },
        };
        CapacitorHttp.post(options)
          .then((response) => {
            console.log('SignalRBroadcastService', response)
            if (response.status === 200) {
              if (retry < 3) {
                setTimeout(() => {
                  retry = retry + 1;
                  this.authMiddlewareHandler(state, code, state_data, retry)
                }, 3000)
              }
            } else {
              this.authService.showLoginErrorModal(state);
            }
          })
          .catch((error) => {
            console.log('SignalRBroadcastService', error)
            this.authService.showLoginErrorModal(state);
          });
      } else {
        console.log('AuthComponent authMiddlewareHandler for Web');
        this.authService.acquireB2CAccessToken(code);
      }
    } else {
      console.log('AuthComponent authMiddlewareHandler for logout');
      if(state_data['access_denied'])
        window.location.href = "access_denied";
      else
        window.location.href = this.authService.getB2CLoginUrl(state, state_data['code_challange']);
    }
  }
}